import {FuseLoadable} from '@fuse';

export const RpInfrastructureConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/apps/readypayiaas/RpInfrastructure',
            component: FuseLoadable({
                loader: () => import('./RpInfrastructure')
            })
        },
      
       
      

    ]
};

